// let maxQuantity = ( typeof ProductGridContainer !== "undefined" ) ? parseInt(ProductGridContainer.dataset.bundleMaxLimit) || 25 : 25;

if (typeof maxQuantity === "undefined") {
  var maxQuantity = ( typeof ProductGridContainer !== "undefined" ) ? parseInt(ProductGridContainer.dataset.bundleMaxLimit) || 25 : 25;
}

if (typeof checkMin === "undefined") {
  var checkMin = false;
}
window.mainInit = function() {
	const _selectors = {
		addTocartInsummaryBtn: '.js-add-bundle-btn:not(.soldout)',
		bundleSummaryWrap: ".bundle-summary-wrap",
		buddleCounts: ".bundle-counts",
		addToCartMain: ".js-addtocart-main",
		addToCartButton: ".js-addtocart-main-button",
		removeBundleCartBtn: ".js-remove-bundle-cart-btn",
		jsAddTocartMainButton: ".js-addtocart-main-button",
        bundleItems: ".bundle-item",
	};
	window.bundleBuilder = {
		_init: function() {
			this._bindEvents();
		},
      
		_bindEvents: function() {
			let _this = this;
			document.querySelectorAll(_selectors.addTocartInsummaryBtn).forEach((element) => {
				element.addEventListener("click", _this._addTocartInsummary.bind(this), false)
			});
			// if(document.querySelector(_selectors.addToCartMain)) {
			// 	document.querySelector(_selectors.addToCartMain).addEventListener("click", this._mainAddToCart.bind(this));
			// }
            if(document.querySelector(_selectors.addToCartMain)) {
				document.querySelectorAll(_selectors.addToCartMain).forEach((ele) => {
					ele.addEventListener("click", this._mainAddToCart.bind(this));
				});
			}
			if(document.querySelector(_selectors.removeBundleCartBtn)) {
				document.querySelectorAll(_selectors.removeBundleCartBtn).forEach((ele) => {
					ele.addEventListener("click", _this._cartActionRemove.bind(this), false)
				});
			}
			if(document.querySelector(_selectors.jsAddTocartMainButton)) {
				document.querySelector(_selectors.jsAddTocartMainButton).addEventListener("click", this._mainAddtoCartAction.bind(this));
			}
		},
        _updateBtnSummary: function() {
          let bundleItems = document.querySelectorAll(_selectors.bundleItems);

          bundleItems.forEach(function (bundleItem) {
            let dataAvailable = bundleItem.dataset.available;
            let jsAddBundleBtn = bundleItem.querySelector(".js-add-bundle-btn");
            if(dataAvailable == true || dataAvailable == 'true'){
              if(jsAddBundleBtn && jsAddBundleBtn.hasAttribute('disabled')){
                jsAddBundleBtn.removeAttribute('disabled');
              }
            }else{
              if(jsAddBundleBtn){
                jsAddBundleBtn.setAttribute('disabled', 'disabled');
              }
            }
            if(!jsAddBundleBtn.classList.contains("hidden") && bundleItem.classList.contains("item-added")){
              bundleItem.classList.remove('item-added');
            }
          });
          
        },
		_addTocartInsummary: function(event) {
          let closestButton = event.currentTarget;

          /* 
            condition to check the productr is in bundle
            Descrip-tion: If text is "-" the remove the product, else add product to the bundle
          */
            
            let ww = window.innerWidth;
            let hideBtn = false;
            if(ww <= 575){
              hideBtn = true;
            }

            let productBottom = event.target.closest('.product-bottom');
            if(productBottom){
              let qtyVal = productBottom.querySelector('.update-cart--template').value;
              if(qtyVal == 0){
                productBottom.querySelector('.update-cart--template').value = 1;
              }
            }

           if (event.target.tagName.toLowerCase() === 'span') {
             let closestButton = event.target.closest('button');
             if (closestButton) {
                 closestButton.querySelector("span").innerText = "Add";
                 closestButton.classList.add("item-added");
                 closestButton.closest(".bundle-item").classList.add("item-added","js-added-bundle");
                 closestButton.classList.add("hidden");
                 closestButton.closest('.product-bottom').querySelector('.bundle-qty-wrap').style.display = "flex";
             }
           }else{
              event.target.classList.add("item-added");
              event.target.setAttribute("disabled", "disabled");
              event.target.closest(".bundle-item").classList.add("item-added","js-added-bundle");
              event.target.classList.add("hidden");
              event.target.closest('.product-bottom').querySelector('.bundle-qty-wrap').style.display = "flex";
           }

          let getVariantId = "";
          
          if (event.target.tagName.toLowerCase() === 'span') {
            let closestButton = event.target.closest('button');
            if (closestButton) {
               getVariantId = closestButton.dataset.variantId;
            }
          }else{
              getVariantId = event.target.dataset.variantId;
          }
          
            document.querySelector(`.js-bundle-data-${getVariantId}`).querySelector('input[name="qty"]').value = 1;
			let	getCurrentVarHtml = document.querySelector(`.js-bundle-data-${getVariantId}`).innerHTML;
            let html = new DOMParser().parseFromString(getCurrentVarHtml, 'text/html');
            let qtyInput = html.querySelector('input[name="qty"]');
            if ((qtyInput && Number(qtyInput.value) == 0) || (qtyInput && Number(qtyInput.value) == 1)) {
              qtyInput.value = 1;
              let updatedHtmlString = html.documentElement.innerHTML;
              getCurrentVarHtml = updatedHtmlString;
            }
           
			let	variantIdArray = [];
			let	countQtyVal = 0;
			let	bundleProducts = document.querySelectorAll(".bundle-summary-wrap .bundle-summary-item");
			for(var i = 0; i < bundleProducts.length; i++) {
				let currentIds = bundleProducts[i].getAttribute("data-variant-id");
				variantIdArray.push(currentIds);
			}
			document.querySelectorAll(".bundle-summary-wrap .bundle-summary-item .js-mini-bundle-product-qty .qty").forEach((ele) => {
				countQtyVal += parseInt(ele.value);
			});
            
			if(countQtyVal == maxQuantity) {
              if (event.target.tagName.toLowerCase() === 'span') {
                let closestButton = event.target.closest('button');
                if (closestButton) {
                  closestButton.innerHTML = "ADD TO BUNDLE";
                  closestButton.classList.remove("item-added");
                }
              }else{
                  event.target.innerHTML = "ADD TO BUNDLE";
                  event.target.classList.remove("item-added");
              }
              // event.target.innerHTML = "ADD TO BUNDLE";
              // event.target.classList.remove("item-added");
				return;
			}
			if(variantIdArray.indexOf(getVariantId) == -1) {
				document.querySelector(_selectors.bundleSummaryWrap).insertAdjacentHTML("afterbegin", getCurrentVarHtml);
                let firstChild = document.querySelector('.bundle-summary-wrap :first-child');
                if (firstChild) {
                  if(firstChild.querySelector('input[name="qty"]').value && firstChild.querySelector('input[name="qty"]').value == 0){
                    firstChild.querySelector('input[name="qty"]').value = 1;
                  }
                }
			}
			document.querySelector(_selectors.addToCartMain).classList.remove("view-hide");
			// document.querySelector(_selectors.addToCartButton).classList.remove("view-hide");
			document.querySelectorAll(".js-remove-btn").forEach((element) => element.removeEventListener("click", bundleBuilder._removeProductFromSummary.bind(this)));
			document.querySelectorAll(".js-remove-btn").forEach((element) => element.addEventListener("click", bundleBuilder._removeProductFromSummary.bind(this)));
			document.querySelectorAll(".js-update-bundle-btn").forEach((element) => element.addEventListener("click", bundleBuilder._updateProductFromSummary.bind(this)));
			bundleBuilder._getProductData();
			bundleBuilder._getProductImages();
            bundleBuilder._updateButtons(bundleBuilder._checkQtyToMakeDisabled());
            window.matchHeight('.bundle-summary-item-meta-wrap');
            this._updateProgressBarandValues();
            this._updateBtnSummary();
		},

        _updateProgressBarandValues(){
          countQtyValTemp = 0;
          document.querySelectorAll(".bundle-summary-wrap .bundle-summary-item .js-mini-bundle-product-qty .qty").forEach((ele) => {
            countQtyValTemp += parseInt(ele.value);
          });
          document.querySelectorAll(".bundle__main--counter").forEach(el => {
            el.querySelector(".bundle--counter .bundle-counts").innerHTML = countQtyValTemp;
            if(el.querySelector(".bundle__progress--bar") != null) {
              el.querySelector(".bundle__progress--bar .fill__progress--bar").style.width = `${ this._calculatePercentage(countQtyValTemp, maxQuantity) }%`;
            }

            if(document.querySelector('.bundle__summary--message') != null){
              if(countQtyValTemp > 0) {
                document.querySelector('.bundle__summary--message').style.display = 'none';
              } else {
                document.querySelector('.bundle__summary--message').style.display = 'block';
              }
            }

            var remainQtyMsg = document.querySelectorAll('.remain--counter');
            if(remainQtyMsg.length > 0){
              let remainingQty = maxQuantity - countQtyValTemp;
 
              if (remainingQty == 0){
                // document.querySelector('.remain--counter.step-2').innerHTML = 'Select items in Step 1 to begin! Then adjust the quantity of each item in your bundle below.'
                remainQtyMsg.forEach(element => {
                  element.innerHTML = `You're good to go!`;
                });
              } else {
                if(countQtyValTemp > 0) {
                  remainQtyMsg.forEach(element => {
                    element.innerHTML = `You’ve goT <span>${remainingQty}</span> to go!`;
                  });
                } else {
                  remainQtyMsg.forEach(element => {
                    element.innerHTML = `Add An Item to Begin!`;
                  });
                }
              }
            }
          });

          // if(countQtyValTemp < maxQuantity) {
          //   document.querySelectorAll(".js-add-bundle-btn").forEach(el => {
          //     el.removeAttribute("disabled");
          //   })
          // } else {
          //   document.querySelectorAll(".js-add-bundle-btn").forEach(el => {
          //     el.setAttribute("disabled", true);
          //   })
          // }

          this._updateBtnSummary();
          
          setTimeout(function(){
            if(countQtyValTemp < maxQuantity) {
              document.querySelectorAll(".js-add-bundle-btn").forEach(el => {
                el.removeAttribute("disabled");
              })
              if(document.querySelector('.bundle--limit-error')) {
                document.querySelector('.bundle--limit-error').classList.remove("show");
              }
            } else {
              document.querySelectorAll(".js-add-bundle-btn").forEach(el => {
                el.setAttribute("disabled", true);
              });
              if(document.querySelector('.bundle--limit-error')) {
                document.querySelector('.bundle--limit-error').classList.add("show");
              }
            }
          },500);
          
        },

        _calculatePercentage(value, max) {
          return (value / max) * 100;
        },
      
        _checkQtyToMakeDisabled(){
          let Items = document.querySelectorAll(`.bundle-item.js-added-bundle`),
              addedQty = 0;

          Items.forEach(function(element) {
            addedQty += parseInt(element.querySelector('[name="quantity"]').value);
          });

          let makeDisabled = false,
              action = null;
          if(addedQty == (maxQuantity - 1)){
            action = "disablePlus"
          }else if (addedQty >= maxQuantity) {
            makeDisabled = true;
            action = "disableAtc_plusBtn"
          }else{
            action = "removeDisable_plus"
          }
          
          return {
            makeDisabled :makeDisabled,
            action: action
          };
        },
      
		_updateButtonOnQtyChange(qty,currentBudnelItem,event,currentBudnelItemSummary) {
          if(currentBudnelItem){
              let getVarId = currentBudnelItem.getAttribute('data-variantid');
              
              if(event == 'plus'){
                if(document.querySelector(`.bundle-summary-wrap .bundle-summary-item .js-mini-bundle-product-qty[data-variant-id="${getVarId}"] .plus`)){
                  document.querySelector(`.bundle-summary-wrap .bundle-summary-item .js-mini-bundle-product-qty[data-variant-id="${getVarId}"] .plus`).click();
                }
              }else if(event == 'minus'){
                if(document.querySelector(`.bundle-summary-wrap .bundle-summary-item .js-mini-bundle-product-qty[data-variant-id="${getVarId}"] .minus`)){
                  document.querySelector(`.bundle-summary-wrap .bundle-summary-item .js-mini-bundle-product-qty[data-variant-id="${getVarId}"] .minus`).click();
                }
              }
              setTimeout(function(){
                if(document.querySelector(`.bundle-summary-wrap .bundle-summary-item .js-update-bundle-btn[data-variant-id="${getVarId}"]`)) {
                  document.querySelector(`.bundle-summary-wrap .bundle-summary-item .js-update-bundle-btn[data-variant-id="${getVarId}"]`).click();
                }
              },1000)
            bundleBuilder._getProductData();
          }
          if(currentBudnelItemSummary){
            let getSummuryVarId = currentBudnelItemSummary.getAttribute('data-variant-id'),
                summQty = Number(currentBudnelItemSummary.querySelector('.js-mini-bundle-product-qty .qty').value);

            var minusElements = document.querySelectorAll(`.quantity[data-variant-id="${ getSummuryVarId }"] .minus`);

            if(minusElements.length > 0) {
              minusElements.forEach((item) => {
                if(summQty > 1) {
                  item.classList.add('is-active');
                } else {
                  item.classList.remove('is-active');
                }
              });
            }
            
            if(event == 'plus'){
              document.querySelector(`.main-carousel-bundle .product-item .js-qty-btn-wrap[data-variant-id="${getSummuryVarId}"] .qty`).value = summQty;
            }else if(event == 'minus'){
              document.querySelector(`.main-carousel-bundle .product-item .js-qty-btn-wrap[data-variant-id="${getSummuryVarId}"] .qty`).value = summQty;
            }
            
            bundleBuilder._getProductData();

            if(document.querySelector(`.bundle-wrapper .bundle-summary-item[data-variant-id="${ getSummuryVarId }"] .js-total-price`)){
              var itemPrice = parseInt(document.querySelector(`.js-mini-bundle-product-qty[data-variant-id="${ getSummuryVarId }"] [name="qty"]`).getAttribute('data-product-discount-price'));
              var totalPrice = parseInt(itemPrice * summQty);
              document.querySelector(`.bundle-wrapper .bundle-summary-item[data-variant-id="${ getSummuryVarId }"] .js-total-price`).innerHTML = Shopify.formatMoney(totalPrice, window.Currency.shopCurrency);
            }
          }
          this._updateBtnSummary();
		},
      
		_updateButtons: function(actionData,currentBudnelItem) {
          function disablePlus(selector,makeDisable) {
            document.querySelectorAll(selector).forEach(function (grid) {
              grid.querySelector('.js-qty-btn-wrap  .plus.js-main-product-qty-action').disabled = makeDisable;
            });
          }

          function disableAtc(selector, makeDisable) {
            document.querySelectorAll(selector).forEach(function (grid) {
              const button = grid.querySelector(_selectors.addTocartInsummaryBtn);
              if (button) {
                button.disabled = makeDisable;
              }
            });
          }
          
          if(actionData.action == 'disablePlus'){
            disablePlus(`.bundle-item:not(.js-added-bundle)`,true);
            disableAtc(`.bundle-item:not(.js-added-bundle)`,false);
            disablePlus(`.bundle-item.js-added-bundle`,false);
          }
          if(actionData.action == 'disableAtc_plusBtn'){
            disablePlus(`.bundle-item`,true);
            disableAtc(`.bundle-item:not(.js-added-bundle)`,true);
          }
          if(actionData.action == 'removeDisable_plus'){
            disablePlus(`.bundle-item`,false);
            disableAtc(`.bundle-item:not(.item-added)`,false)
          }
          this._updateBtnSummary();
		},

        _updateSavedBundlePrice : function(originalVal, discountedVal){
          originalVal = Number((originalVal / 100).toFixed(2));
          discountedVal = Number((discountedVal / 100).toFixed(2));
          let youSavelue = (originalVal - discountedVal).toFixed(2);
          document.querySelector(".bundle-summary-total .total__saved--amt span").innerHTML = Shopify.formatMoney(youSavelue, window.Currency.shopCurrency);
        },
      
		_getProductData: function(getVariantId){
			let count = 0,
				subtotal = 0,
                subtotalDiscount = 0;
			document.querySelectorAll(".bundle-summary-wrap .bundle-summary-item .js-mini-bundle-product-qty .qty").forEach((item) => {
				count += parseInt(item.value);
				subtotal += parseInt(item.getAttribute("data-product-price") * item.value);
              
              if(item.getAttribute("data-bundle-exist")=='true'){
                document.querySelector(".bundle-summary-total .js-subtotal-value-discount").classList.remove('view-hide');
                // document.querySelector(".summery-total .js-subtotal-value-discount").classList.remove('view-hide');
                subtotalDiscount += parseInt(item.getAttribute("data-product-discount-price") * item.value);
              }else{
                subtotalDiscount += parseInt(item.getAttribute("data-product-price") * item.value);
              }

			});
          
            if(count == maxQuantity){
              if(document.querySelector(_selectors.addToCartMain)) {
                document.querySelectorAll(_selectors.addToCartMain).forEach(function(button) {
                    button.removeAttribute('disabled');
                });
              }
            }
			// document.querySelector(_selectors.buddleCounts).innerHTML = count;
            document.querySelectorAll(_selectors.buddleCounts).forEach(el => {
              el.innerHTML = count;
            });

          
			document.querySelector(".bundle-summary-total .js-subtotal-value").innerHTML = Shopify.formatMoney(subtotalDiscount, window.Currency.shopCurrency);
            document.querySelector(".bundle-summary-total .js-subtotal-value-discount").innerHTML = Shopify.formatMoney(subtotal, window.Currency.shopCurrency);

            this._updateSavedBundlePrice(subtotal, subtotalDiscount)
      
			// document.querySelector(".summery-total .js-subtotal-value").innerHTML = Shopify.formatMoney(subtotalDiscount, window.Currency.shopCurrency);
   //          document.querySelector(".summery-total .js-subtotal-value-discount").innerHTML = Shopify.formatMoney(subtotal, window.Currency.shopCurrency);
          
			if(count >= maxQuantity) {
				document.querySelector(_selectors.addToCartMain).removeAttribute("disabled", "disabled");
				// document.querySelector(_selectors.addToCartButton).removeAttribute("disabled", "disabled");
			}
			if(count < maxQuantity) {
				document.querySelector(_selectors.addToCartMain).setAttribute("disabled", "disabled");
				// document.querySelector(_selectors.addToCartButton).setAttribute("disabled", "disabled");
			}
            bundleBuilder._updateButtonOnQtyChange();
          
          if(count == 0){
            document.querySelectorAll(`.bundle-item:not(.item-added) ${_selectors.addTocartInsummaryBtn}`).forEach(function(ele){
              ele.removeAttribute('disabled');
              ele.classList.remove('disabled');
            });
            document.querySelectorAll(`.js-qty-btn-wrap  .plus.js-main-product-qty-action`).forEach(function(ele){
              ele.removeAttribute('disabled');
              ele.classList.remove('disabled');
            })
          }

          let totalOriginalValue = 0
          document.querySelectorAll(".bundle-summary .product-price-with-discount-wrap").forEach(el => {
            let oriPrice = parseInt(el.dataset.original_price);
            let oriQty = parseInt(el.closest(".bundle__summary--wrap").querySelector("[name='qty']").value);
            let originalTotal = oriPrice * oriQty;
            totalOriginalValue = totalOriginalValue + originalTotal; 
          })
          // document.querySelector(".js-subtotal-value-discount").innerHTML = Shopify.formatMoney(totalOriginalValue, window.Currency.shopCurrency);


          setTimeout(function() {
            if(document.querySelector(".bundle-summary-wrap") != null){
              if(document.querySelectorAll('.bundle-summary-wrap .bundle-summary-item').length == 0){
                document.querySelector(".bundle-summary-wrap").classList.add('empty--div');
              } else {
                document.querySelector(".bundle-summary-wrap").classList.remove('empty--div');
              }
            }
          }, 1000);
          this._updateBtnSummary();
		},
      
		_removeProductFromSummary: function(e) {
			let productId = e.target.getAttribute("data-product-id"),
				count = 0,
				subtotal = 0,
                variantId = e.target.getAttribute("data-variant-id"),
                resetValueMainBundle = document.querySelector(`.bundle-item[data-variantid="${variantId}"]`),
                resetsummeryProduct = document.querySelector(`.bundle-summary-item[data-variant-id="${variantId}"]`);
          
			if(e.target.closest(".bundle-summary-wrap") != null) {
              e.target.closest(".bundle-summary-wrap").querySelector(`.bundle-summary-item[data-product-id='${productId}']`).remove();
			}
			document.querySelectorAll(".bundle-summary-wrap .bundle-summary-item .js-mini-bundle-product-qty .qty").forEach((item) => {
              count += parseInt(item.value);
              subtotal += parseInt(item.getAttribute("data-product-price") * item.value);
			});
          
			// document.querySelector(_selectors.buddleCounts).innerHTML = count;
            document.querySelectorAll(_selectors.buddleCounts).forEach(el => {
            	el.innerHTML = count;
            });

			document.querySelector(".bundle-summary-total .js-subtotal-value").innerHTML = Shopify.formatMoney(subtotal, window.Currency.shopCurrency);
			if(subtotal == 0) {
              document.querySelector(_selectors.addToCartMain).classList.add("view-hide");
              // document.querySelector(_selectors.addToCartButton).classList.add("view-hide");
              document.querySelector(".bundle-summary-total .js-subtotal-value-discount").classList.add('view-hide');
              document.querySelector(".summery-total .js-subtotal-value-discount").classList.add('view-hide');
			}
			if(count < maxQuantity) {
              document.querySelector(_selectors.addToCartMain).setAttribute("disabled", "disabled");
              // document.querySelector(_selectors.addToCartButton).setAttribute("disabled", "disabled");
			}
          
			bundleBuilder._getProductImages();
			bundleBuilder._getProductData();
            bundleBuilder._resetMainBundle(resetValueMainBundle,resetsummeryProduct);
            bundleBuilder._updateButtons(bundleBuilder._checkQtyToMakeDisabled());

            if(productId){
              let productCollection = document.querySelector('.product-collection');
              if(productCollection){
                // let arrowHtml = `<span class="atc_arrow">Plus</span>`;
                productCollection.querySelector(`.qty[data-id="${productId}"]`).value = 0;
                productCollection.querySelector(`.js-main-product-qty-action[data-id="${productId}"]`).click();
                productCollection.querySelector(`.js-add-bundle-btn[data-variant-id="${productId}"]`).classList.remove('hidden');
                productCollection.querySelector(`.js-add-bundle-btn[data-variant-id="${productId}"]`).classList.remove('item-added');
                productCollection.querySelector(`.js-add-bundle-btn[data-variant-id="${productId}"]`).removeAttribute('disabled');
                productCollection.querySelector(`.js-add-bundle-btn[data-variant-id="${productId}"]`).innerHTML = arrowHtml;
              }
            }
           this._updateBtnSummary();
		},
      
        _resetMainBundle:function(reset,resetsummeryProduct){
          resetsummeryProduct.querySelector('.js-mini-bundle-product-qty .qty').setAttribute('value',1);
          reset.classList.remove('item-added',"js-added-bundle");
          reset.querySelector('.js-add-bundle-btn').classList.remove('item-added');
          reset.querySelector('.js-add-bundle-btn').innerHTML='ADD TO BUNDLE';
          reset.querySelector('.js-add-bundle-btn').removeAttribute('disabled');
          reset.querySelector('.js-qty-btn-wrap .qty').value = '1';
          this._updateBtnSummary();
        },
      
		_getProductImages: function() {
			let imagesArray = [],
				bundleProducts = document.querySelectorAll(".bundle-summary-wrap .bundle-summary-item"),
				imagesWrap = document.querySelectorAll(".added-bundle-wrap .added-bundle-wrap-image img"),
				globalImage = "https://cdn.shopify.com/s/files/1/0246/5411/8978/files/Oval_Copy_4.png?v=1664370912";
			bundleProducts.forEach((item) => {
				let itemQty = parseInt(item.querySelector(".js-mini-bundle-product-qty .qty").value),
					get_imageUrl = item.querySelector(".bundle-summary-item-image").getAttribute("data-productimage-url");
				for(var i = 0; i < itemQty; i++) {
					imagesArray.push(get_imageUrl);
				}
			});
			imagesWrap.forEach((element, index) => {
				if(index < imagesArray.length) {
					element.setAttribute("src", imagesArray[index]);
					element.classList.add("image-uploaded");
				} else {
					element.setAttribute("src", globalImage);
					element.classList.remove("image-uploaded");
				}
			});
		},
      
		_updateProductFromSummary: function(ele) {
			let updateProdutId = ele.target.getAttribute("data-product-id"),
				updateVariantId = ele.target.getAttribute("data-variant-id"),
				subtotal = 0,
				count = 0,
				currentQtyValue = ele.target.closest(`.bundle-summary-item[data-product-id="${updateProdutId}"]`).querySelector(".js-mini-bundle-product-qty .js-qty").value;
			document.querySelectorAll(".bundle-summary-wrap .bundle-summary-item .js-mini-bundle-product-qty .qty").forEach((item) => {
				subtotal += parseInt(item.getAttribute("data-product-price") * item.value);
			});
			document.querySelector(".bundle-summary-total .js-subtotal-value").innerHTML = Shopify.formatMoney(subtotal, window.Currency.shopCurrency);
			document.querySelectorAll(".bundle-summary-wrap .bundle-summary-item .js-mini-bundle-product-qty .qty").forEach((item) => {
				count += parseInt(item.value);
			});
			// document.querySelector(_selectors.buddleCounts).innerHTML = count;
            document.querySelectorAll(_selectors.buddleCounts).forEach(el => {
            	el.innerHTML = count;
            });

			bundleBuilder._getProductImages();
			bundleBuilder._getProductData();
          
			if(document.querySelector(`.bundle-item .js-qty-btn-wrap[data-product-id="${updateProdutId}"] .qty`))
            {
              document.querySelector(`.bundle-item .js-qty-btn-wrap[data-product-id="${updateProdutId}"] .qty`).value = currentQtyValue;
            }

            if(document.querySelector(`.bundle-item .js-qty-btn-wrap[data-product-id="${updateProdutId}"] .qty`)){
              if(document.querySelector(`.bundle-item .js-qty-btn-wrap[data-product-id="${updateProdutId}"] .qty`).value == 0) {
                  document.querySelector(`.bundle-item .js-add-bundle-btn[data-product-id="${updateProdutId}"]`).setAttribute("disabled", "disabled");
              } else {
                  document.querySelector(`.bundle-item .js-add-bundle-btn[data-product-id="${updateProdutId}"]`).removeAttribute("disabled", "disabled");
                // console.log('removeAttribute:: ')
              }
            }
          
			if(currentQtyValue == 0) {
				ele.target.closest(`.bundle-summary-item[data-product-id="${updateProdutId}"]`).remove();
			}
            this._updateBtnSummary();

            // console.log('22222 :: ',count)

  
            setTimeout(function(){
              if(count < maxQuantity) {
                document.querySelectorAll(".js-add-bundle-btn").forEach(el => {
                  el.removeAttribute("disabled");
                })
                if(document.querySelector('.bundle--limit-error')) {
                  document.querySelector('.bundle--limit-error').classList.remove("show");
                }
              } else {
                document.querySelectorAll(".js-add-bundle-btn").forEach(el => {
                  el.setAttribute("disabled", true);
                });
                if(document.querySelector('.bundle--limit-error')) {
                  document.querySelector('.bundle--limit-error').classList.add("show");
                }
              }
            },500);
          
		},
      
		_mainAddToCart: function(e) {
			e.preventDefault();
			let _uniqueBundleId = new Date().getTime().toString(),
				items = [],
				itemsProp = {},
				counter = 0;
			document.querySelectorAll(".bundle-summary-wrap .bundle-summary-item").forEach(function(ele) {
				let getCurrentQty = parseInt(ele.querySelector(".js-mini-bundle-product-qty .qty").value);
				let tempItem = {},
                    getOptionSize = ele.getAttribute('data-option-size');
              
				tempItem["quantity"] = getCurrentQty;
				tempItem["id"] = ele.dataset.variantId;
				tempItem["properties"] = {
					_bundle_id: _uniqueBundleId,
					_default_qty: getCurrentQty,
                    _bundleTag: _uniqueBundleId
				};
				counter++;

              let handleVariantTitle = ele.dataset.productTitle?.toLowerCase();

              if (handleVariantTitle?.includes("default")) {
                itemsProp[`BUNDLE${counter}`] = `${ele.dataset.productTitle} (${getCurrentQty})`;
              }else{
                // itemsProp[`BUNDLE${counter}`] = `${ele.dataset.proTitle} / ${ele.dataset.productTitle} (${getCurrentQty})`;
                itemsProp[`BUNDLE${counter}`] = `${ele.dataset.proTitle ? ele.dataset.proTitle + ' / ' : ''}${ele.dataset.productTitle} (${getCurrentQty})`;

              }
              
              // if(getOptionSize=='true'){
              //   itemsProp[`BUNDLE${counter}`] = `${ele.dataset.productTitle} (${getCurrentQty})`;
              // }else if(getOptionSize=='false'){
              //   itemsProp[`BUNDLE${counter}`] = `${ele.dataset.proTitle} / ${ele.dataset.productTitle} (${getCurrentQty})`;
              // }else{
              //   itemsProp[`BUNDLE${counter}`] = `${ele.dataset.productTitle} (${getCurrentQty})`;
              // }
				itemsProp["__main_bundle_id"] = _uniqueBundleId;
                itemsProp["__main_bundle_products_count"] = maxQuantity;
				items.push(tempItem);
			});
			let tempprop = {};
			tempprop["quantity"] = 1;
			tempprop["id"] = document.querySelector(".js-bundle-main-id").value;
			tempprop["properties"] = itemsProp;
			items.push(tempprop);
			let formData = {
				items: items,
			};
          
           // return;
			fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(formData),
			}).then((response) => {
				return response.json();
				console.log("response");
			}).then(function(json) {
				window.location.href = "/cart";
			}).catch((error) => {
				console.error("Error:", error);
			});
		},
      
		_cartActionRemove: function(ele) {
			let cartUpdate = {},
				main_babId = ele.getAttribute("data-build-id"),
				mainProductKey = ele.getAttribute("data-mainkey"),
                cart = ele.closest('cart-items') || ele.closest('cart-drawer-items');
          cart.enableLoading(ele.dataset.index);
          ele.closest('.cart-product-item').dataset.key.split(',').forEach(key =>{
            cartUpdate[key] = 0;
          });
          let items = {
            updates: cartUpdate,
            sections: cart.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
          };
          
          fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(items)
          }).then(function(data) {
              return data.json();
          }).then(responce => {

              // window.location.reload();
            cart.getSectionsToRender().forEach((section => {
              const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML = cart.getSectionInnerHTML(responce.sections[section.section], section.selector);
            }));

            if(responce?.item_count == 0){
              let drawer = document.querySelector(".drawer");
              if(drawer && !drawer.classList.contains("is-empty")){
                  drawer.classList.add("is-empty");
              }
            }
          }).catch(function(error) {
              console.error('Request failed', error)
          })
          .finally(() => {
            cart.disableLoading(ele.dataset.index);
          });
		},
		_mainAddtoCartAction: function(element) {
			document.querySelector(_selectors.addToCartMain).click();
		},
	};
	window.bundleBuilder._init();
};
window.mainInit();
document.addEventListener("DOMContentLoaded", function() {
  // Event listener for the startover button
  document.querySelectorAll(".bundle-summary-startover").forEach(function(element) {
    element.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector('.confirm-box').style.display = 'block';
    });
  });

  // Event listener for the close button
  document.querySelectorAll(".bundle-summary-startover-close").forEach(function(element) {
    element.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector('.confirm-box').style.display = 'none';
    });
  });
});
